export default {
  successIcon: 'check_circle',
  infoIcon: 'info',
  warningIcon: 'priority_high',
  errorIcon: 'warning',
  iconSize: 24,
  width: 350,
  maxWidth: '80%',
  className: '',
  okLabel: '确定',
  cancelLabel: '取消',
  transition: 'scale' // 'slide-top', 'slide-bottom', 'slide-left', 'slide-right', 'fade', 'scale'
};



// WEBPACK FOOTER //
// ./src/muse-ui-plugin/muse-ui-message/config.js